<div class="math-content" [innerHTML]="renderedContent"></div>